export default "__VITE_ASSET__DrYHH2Dz__"